import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconGallery = memo(({ color = '#F4354C', size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        d="M20.71 4.63l-1.34-1.34c-.37-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.04 0-1.41M7 14a3 3 0 00-3 3c0 1.31-1.16 2-2 2 .92 1.22 2.5 2 4 2 2.21 0 4-1.79 4-4a3 3 0 00-3-3z"
      />
    </Svg>
  );
});
